<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="registerhealthRecord"
      >
        <div class="d-flex mb-4">
          <h2>{{$t('actionListmod.updateHealthRecord')}}</h2>
          <v-spacer></v-spacer>
          <v-btn
            width="146"
            color="primary"
            outlined
            exact
            class="mr-2"
            :to="{ name: 'SingleDailyTask' }"
            >{{$t('actionListmod.cANCEL')}}</v-btn
          >
          <v-btn type="submit" width="146" color="primary">{{$t('actionListmod.sUBMIT')}}</v-btn>
        </div>
        <v-card elevation="0" class="px-5">
          <v-card-text v-if="users.length > 0">
            <v-expansion-panels focusable v-model="panel" multiple>
              <v-expansion-panel
                v-for="(item, index) in users"
                :key="index"
                class="mt-5"
              >
                <v-expansion-panel-header>
                  <!-- <v-card outlined class="mb-5"> -->
                  <v-list-item>
                    <v-list-item-content>
                      <v-row>
                        <v-col>
                          <v-list-item-avatar
                            class="green2"
                            dark
                          ></v-list-item-avatar>
                        </v-col>
                        <v-col>
                          <v-list-item-title class="text-h6 mb-1">
                            {{$t('actionListmod.iD')}}
                          </v-list-item-title>
                          <v-list-item-subtitle
                            :value="
                              (animal[index].animalNumber =
                                item.animal.animalNumber)
                            "
                            >{{
                              item.animal.animalNumber
                            }}</v-list-item-subtitle
                          >
                        </v-col>
                        <v-col>
                          <v-list-item-title class="text-h6 mb-1">
                           {{$t('actionListmod.tAG')}}
                          </v-list-item-title>
                          <v-list-item-subtitle>{{
                            item.animal.tagNumber
                          }}</v-list-item-subtitle>
                        </v-col>
                        <v-col>
                          <v-list-item-title class="text-h6 mb-1">
                            {{$t('actionListmod.dateOfbirth')}}
                          </v-list-item-title>
                          <v-list-item-subtitle>{{
                            item.animal.dob
                          }}</v-list-item-subtitle>
                        </v-col>
                        <v-col>
                          <v-list-item-title class="text-h6 mb-1">
                            {{$t('actionListmod.gENDER')}}
                          </v-list-item-title>
                          <v-list-item-subtitle>{{
                            item.animal.gender
                          }}</v-list-item-subtitle>
                        </v-col>
                        <v-col>
                          <v-list-item-title class="text-h6 mb-1">
                            {{$t('actionListmod.bREED')}}
                          </v-list-item-title>
                          <v-list-item-subtitle>{{
                            item.animal.breed
                          }}</v-list-item-subtitle>
                        </v-col>
                        <v-col>
                          <v-list-item-title class="text-h6 mb-1">
                            {{$t('actionListmod.regDate')}}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            {{ item.animal.createdAt }}</v-list-item-subtitle
                          >
                        </v-col>
                        <v-col>
                          <v-list-item-title class="text-h6 mb-1">
                           {{$t('actionListmod.status')}}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            {{ item.status }}</v-list-item-subtitle
                          >
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                  </v-list-item>
                  <!-- </v-card> -->
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row class="mt-5">
                    <v-col lg="3" md="6" sm="6" xs="6">
                      <label
                        class="subtitle-1 font-weight-medium black--text"
                        for="treatment"
                        >{{$t('actionListmod.treatment')}}<span class="red--text">*</span></label
                      >
                      <v-text-field
                        type="text"
                        placeholder="e.g XXXX"
                        outlined
                        dense
                        :rules="healthRules.treatment"
                        v-model="animal[index].treatment"
                      ></v-text-field>
                    </v-col>
                    <v-col lg="3">
                      <label
                        class="subtitle-1 font-weight-medium black--text"
                        for="reasonTreatment"
                        >{{$t('actionListmod.reasonOftreatment')}}<span class="red--text">*</span></label
                      >
                      <v-text-field
                        type="text"
                        placeholder="e.g XXXX"
                        outlined
                        dense
                        v-model="animal[index].treatmentReason"
                        :rules="healthRules.treatmentReason"
                      ></v-text-field>
                    </v-col>
                    <v-col lg="3" md="6" sm="6" xs="6">
                      <label
                        class="subtitle-1 font-weight-medium black--text"
                        for="treatmentDate"
                        >{{$t('actionListmod.treatmentDate')}}<span class="red--text">*</span></label
                      >
                      <v-menu
                        v-model="treatmentMenu[index]"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            append-icon="mdi-calendar"
                            outlined
                            dense
                            placeholder="e.g XXXX"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            v-model="animal[index].treatmentDate"
                            :rules="healthRules.treatmentDate"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          @input="treatmentMenu[index] = false"
                          v-model="animal[index].treatmentDate"
                          :min="new Date().toISOString().substr(0, 10)"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col lg="3">
                      <label
                        class="subtitle-1 font-weight-medium black--text"
                        for="diagnosis"
                        >{{$t('actionListmod.dIAGNOSIS')}}<span class="red--text">*</span></label
                      >
                      <v-text-field
                        type="text"
                        placeholder="e.g XXXX"
                        outlined
                        dense
                        v-model="animal[index].diagnosis"
                        :rules="healthRules.diagnosis"
                      ></v-text-field>
                    </v-col>
                    <v-col lg="3" md="6" sm="6" xs="6">
                      <label
                        class="subtitle-1 font-weight-medium black--text"
                        for="drugId"
                        >{{$t('actionListmod.drugId')}}<span class="red--text">*</span></label
                      >
                      <v-text-field
                        type="text"
                        placeholder="e.g XXXX"
                        outlined
                        dense
                        v-model="animal[index].drugId"
                        :rules="healthRules.drugId"
                      ></v-text-field>
                    </v-col>
                    <v-col lg="3" md="6" sm="6" xs="6">
                      <label
                        class="subtitle-1 font-weight-medium black--text"
                        for="drugName"
                        >{{$t('actionListmod.drugName')}}<span class="red--text">*</span></label
                      >
                      <v-text-field
                        type="text"
                        placeholder="e.g XXXX"
                        outlined
                        dense
                        v-model="animal[index].drugName"
                        :rules="healthRules.drugName"
                      ></v-text-field>
                    </v-col>
                    <v-col lg="3" md="6" sm="6" xs="6">
                      <label
                        class="subtitle-1 font-weight-medium black--text"
                        for="period"
                        >{{$t('actionListmod.drugWithdrawalperiod')}}<span class="red--text">*</span></label
                      >
                      <v-text-field
                        type="text"
                        placeholder="e.g XXXX"
                        outlined
                        dense
                        v-model="animal[index].drugWithdrawPeriod"
                        :rules="healthRules.drugWithdrawPeriod"
                      ></v-text-field>
                    </v-col>
                    <v-col lg="3" md="6" sm="6" xs="6">
                      <label
                        class="subtitle-1 font-weight-medium black--text"
                        for="attending"
                        >{{$t('actionListmod.attendingVeterinarian')}}<span class="red--text">*</span></label
                      >
                      <v-text-field
                        type="text"
                        placeholder="e.g XXXX"
                        outlined
                        dense
                        v-model="animal[index].attendingVeterinarian"
                        :rules="healthRules.attendingVeterinarian"
                      ></v-text-field>
                    </v-col>
                    <v-col lg="3" md="6" sm="6" xs="6">
                      <label
                        class="subtitle-1 font-weight-medium black--text"
                        for="packId"
                        >{{$t('actionListmod.packId')}}<span class="red--text">*</span></label
                      >
                      <v-text-field
                        type="text"
                        placeholder="e.g XXXX"
                        outlined
                        dense
                        v-model="animal[index].packId"
                        :rules="healthRules.packId"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
          <v-card-text v-else>
            <h2 class="text-center">{{$t('actionListmod.noItemsselected')}}</h2>
          </v-card-text>
        </v-card>
        <div class="d-flex mb-4 mt-5">
          <v-spacer></v-spacer>
          <v-btn
            width="146"
            color="primary"
            outlined
            exact
            class="mr-2"
            :to="{ name: 'SingleDailyTask' }"
            >{{$t('actionListmod.cANCEL')}}</v-btn
          >
          <v-btn type="submit" width="146" color="primary">{{$t('actionListmod.sUBMIT')}}</v-btn>
        </div>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
import { healthRules } from "@/validations/HealthRecordRules.js";
export default {
  mounted() {
    document.title = "Action List - Health Record";
    this.users = JSON.parse(localStorage.getItem("items") || "[]");
    console.log("user", this.users);
    for (var i = 0; i < this.users.length; i++) {
      this.animal.push({
        animalNumber: "",
        treatment: "",
        treatmentReason: "",
        treatmentDate: "",
        diagnosis: "",
        drugId: "",
        drugName: "",
        drugWithdrawPeriod: "",
        attendingVeterinarian: "",
        packId: "",
      });
    }
    console.log(this.animal);
  },
  methods: {
    registerhealthRecord() {
      if (!this.$refs.form.validate()) return;
      this.startLoading();
      let data = {
        TENumber: this.$route.params.task_id,
        animals: this.animal,
      };
      console.log("new", data);
      console.log("res", this.animal);
      this.$store
        .dispatch("registerhealthRecord", data)
        .then(async (res) => {
          console.log(res);
          if (res.status == 422) {
            res.data.message.errors.forEach((em) => {
              this.errors[em.param] = em.msg;
            });
          } else {
            this.$notify({
              title: "Health Record Submitted successfully ",
              text: "Health Record Submitted.",
              type: "success",
            });
            await localStorage.removeItem("items");
            this.$router.push({ name: "ActionList" });
          }
        })
        .catch((err) => {
          console.log("err", err.response);
        })
        .finally(() => {
          this.stopLoading();
        });
    },
  },
  data() {
    return {
      panel: 0,
      users: [],
      animal: [],
      treatmentMenu:[],
      healthRules,
      valid: true,
      breadcrumbs: [
        {
          text: this.$t('dashboard'),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t('actionList'),
          disabled: false,
          to: { name: "ActionList" },
          exact: true,
        },
        {
          text: this.$t('actionListmod.healthRecordsubmission'),
          disabled: true,
        },
      ],
    };
  },
  mixins: [loadingMixin],
};
</script>

<style lang="scss" scoped>
::v-deep .green-shadow:hover {
  background-color: $primary_color;
  color: white;
}
</style>